export * from './CustomizationDetailsDressingPortion';
